/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { CloudDatabases } from './components';

export interface ProtectedDataCloudDatabasesPageProps {
    currentPath?: string;
}

export const ProtectedDataCloudDatabasesPage: React.FC<ProtectedDataCloudDatabasesPageProps> = ({ currentPath }) => (
    <TabBarBodyLayout>
        <CloudDatabases stateId={currentPath} />
    </TabBarBodyLayout>
);
